import {
  FilteredItem,
  FilteredItemProps,
} from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';
import { ChargePointIsMaintenance } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/charge-point/charge-point-is-maintenance.enum';
import { useTranslation } from 'react-i18next';

export interface ChargePointIsMaintenanceFilterStateControllerProps {
  value: boolean;
  onRemove: FilteredItemProps['onRemove'];
}

export const ChargePointIsMaintenanceFilterStateController = ({
  value,
  onRemove,
}: ChargePointIsMaintenanceFilterStateControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // DATA FETCHING /////////////////////////////////////////////////////////////

  const chargePointIsMaintenance = value
    ? ChargePointIsMaintenance.TRUE
    : value === false
      ? ChargePointIsMaintenance.FALSE
      : ChargePointIsMaintenance.ALL;

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <FilteredItem
      icon="terminal-maintenance"
      label={t(
        `delmonicos-shared-sdk.outputs-charge-point-is-maintenance.${chargePointIsMaintenance}`,
      )}
      onRemove={onRemove}
    />
  );
};
